var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"prepend-icon":"account_tree","items":_vm.items,"label":_vm.$t('delivery.order.labels.state'),"loading":_vm.loading,"error":_vm.hasInputErrors('state'),"error-messages":_vm.getInputErrors('state'),"color":"secondary","item-color":"secondary"},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }